export default {
  open: false,

  stuck: false,

  toggleNav() {
    this.open = !this.open;
  }
};
